import React, { createContext, useReducer } from 'react'

export const SET_CAPITAL_HARNESS_PLUGIN_DATA = 'SET_CAPITAL_HARNESS_PLUGIN_DATA'
export const UPDATE_CAPITAl_HARNESS_PLUGIN_DATA =
  'UPDATE_CAPITAl_HARNESS_PLUGIN_DATA'
export const SET_SELECTED_CAPITAL_HARNESS_PLUGIN_DATA =
  'SET_SELECTED_CAPITAL_HARNESS_PLUGIN_DATA'
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS'
export const SET_SHOW_HIDE_FORM_POPUP = 'SET_SHOW_HIDE_FORM_POPUP'
export const SET_SHOW_HIDE_DETAILS_POPUP = 'SET_SHOW_HIDE_DETAILS_POPUP'
export const SET_UPLOAD_FILE_STATUS = 'SET_UPLOAD_FILE_STATUS'
export const SET_SHOW_HIDE_ERROR_LOGS = 'SET_SHOW_HIDE_ERROR_LOGS'
export const SET_SHOW_HIDE_COPY_POPUP = 'SET_SHOW_HIDE_COPY_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_CAPITAL_HARNESS_PLUGIN_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CAPITAl_HARNESS_PLUGIN_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_CAPITAL_HARNESS_PLUGIN_DATA: {
      return { ...data, selectedObject: payload.data }
    }
    case SET_SELECTED_IDS: {
      let tempSelectedIds = [...data.selectedIds]
      let item = payload.data
      tempSelectedIds.indexOf(item) === -1
        ? tempSelectedIds.push(item)
        : tempSelectedIds.splice(tempSelectedIds.indexOf(item), 1)
      return { ...data, selectedIds: tempSelectedIds }
    }
    case SET_SHOW_HIDE_FORM_POPUP: {
      return { ...data, showUploadPopup: payload.data, showCopyPopup: false }
    }
    case SET_SHOW_HIDE_DETAILS_POPUP: {
      return { ...data, showDetailsPopup: payload.data, showCopyPopup: false }
    }
    case SET_UPLOAD_FILE_STATUS: {
      return {
        ...data,
        in_process_upload_files: payload.data,
      }
    }
    case SET_SHOW_HIDE_ERROR_LOGS: {
      return { ...data, showErrorPopup: payload.data }
    }
    case SET_SHOW_HIDE_COPY_POPUP: {
      return {
        ...data,
        showCopyPopup: payload.showCopyPopup,
        showDetailsPopup: false,
        selectedObject: payload.data,
        selectedType: payload.selectedType,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  selectedIds: [],
  showUploadPopup: false,
  showDetailsPopup: false,
  in_process_upload_files: false,
  showErrorPopup: false,
  showCopyPopup: false,
  selectedType: {},
}

const CapitalHarnessStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <CapitalHarnessContext.Provider value={[state, dispatch]}>
      {children}
    </CapitalHarnessContext.Provider>
  )
}

export const CapitalHarnessContext = createContext(initialState)
export default CapitalHarnessStore
